import { useQuery } from '@tanstack/react-query';

import { contentTestsQuery, type ContentTestsListParams } from '../api/content-test.api';

export const useContentTests = (
  workspaceId: string | null | undefined,
  params: ContentTestsListParams = {},
  enabled = true,
) => {
  return useQuery({
    ...contentTestsQuery(workspaceId, params),
    enabled: enabled && !!workspaceId,
  });
};
